/**
 * Created by wwei on 2017-06-29.
 */
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import App from "./App";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.js";
import store from "./store";

import { GET_PRE_LOGIN_FEATURES } from "./services/featureFlags";

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>,
  document.getElementById("root")
);

store.dispatch({
  type: GET_PRE_LOGIN_FEATURES
});



// WEBPACK FOOTER //
// ./src/index.js